import { Injectable } from '@angular/core';
import { apiUrl } from '../config/api';
import { SystemStatus } from '../models/system-status';

@Injectable({ providedIn: 'root' })
export class SystemStatusService {
  private readonly apiUrl = apiUrl('/api/settings/public');

  get(): Promise<SystemStatus> {
    return this.request<SystemStatus>(this.apiUrl);
  }

  update(publicOffline: boolean): Promise<SystemStatus> {
    return this.request<SystemStatus>(this.apiUrl, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ public_offline: publicOffline })
    });
  }

  private async request<T>(url: string, init?: RequestInit): Promise<T> {
    const response = await fetch(url, { cache: 'no-store', credentials: 'same-origin', ...init });
    const data = await response.json().catch(() => null);

    if (!response.ok) {
      throw new Error(data?.error ?? 'Errore impostazioni sistema');
    }

    return data as T;
  }
}
